// extracted by mini-css-extract-plugin
module.exports = {"container":"WaitingRoom_container__16hUd","title":"WaitingRoom_title__35p93","desc":"WaitingRoom_desc__1-H08","playersTitle":"WaitingRoom_playersTitle__1ilH9"};